import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import { WarehouseRoutingCheckIn } from "src/types/database";

class WarehouseRoutingCheckInAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/warehouse-routing-check-ins");
  }

  async postWarehouseRoutingCheckIn(
    purchaseOrderId: string,
    body: { products: Array<{ id: string; receivedQty: number }>; defects?: string }
  ): Promise<WarehouseRoutingCheckIn> {
    const pathParam = encodeURIComponent(purchaseOrderId);
    return await this.jwtRequest<WarehouseRoutingCheckIn>("POST", `/${pathParam}`, body);
  }

  async getWarehouseRoutingCheckIns(purchaseOrderId: string): Promise<WarehouseRoutingCheckIn[]> {
    const pathParam = encodeURIComponent(purchaseOrderId);
    return await this.jwtRequest<WarehouseRoutingCheckIn[]>("GET", `/${pathParam}`);
  }
}

export { WarehouseRoutingCheckInAPIService };
